import styled from '@emotion/styled';
import { Typography, blue, grey, tokens } from '@galaxy-react/core';

export const NoSearcResultStyled = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  minHeight: '208px',
  gap: '16px',
  '&:hover': {
    background: tokens.colorTransparentBackground,
  },
  '&:focus-within': {
    background: tokens.colorTransparentBackground,
  },
});

export const NoSearcResultHeading = styled(Typography)({
  color: blue[700],
  fontWeight: tokens.fontWeightRegular,
  margin: '0',
});

export const NoSearchResultDescription = styled('div')({
  color: grey[600],
  display: 'flex',
});

export const NoSearchResultLink = styled('a')({
  color: blue[500],
  marginLeft: tokens.spacingVerticalXS,
  textDecoration: 'none',
});
